import './webpack-set-public-path'

import('./bootstrap')
  .catch(err => console.error(err));

